import React from "react";

const TermsOfUseExperian = () => (
  <div style={{ margin: "0 auto", padding: 30, fontFamily: "Arial, sans-serif"}}>
    <h4>EXPERIAN TERMS AND CONDITIONS</h4>
    <p>
      This End User Agreement is made between you and <b>Monk Capital Private Limited</b>, a private limited company having its registered office at The Platina, B-406, Sy No. 132, 134, H. No. 4-50/1, Gachibowli, K.V.Rangareddy, Seri Lingampally, Telangana, India, 500032.<br />
      {/* The User and CLIENT together: the “Parties”; individually: a “Party”. */}
    </p>

    <p>
      You hereby consent to Client being appointed as your authorised representative to receive your Credit Information from Experian for the purpose of Credit Assessment of the User to advise You on the best credit offers (End Use Purpose) or expiry of 6 months from the date the consent is collected; whichever is earlier.
    </p>

    <p>
      <b>BY EXECUTING THIS AGREEMENT, YOU ARE EXPRESSLY AGREEING TO ACCESS THE EXPERIAN CREDIT INFORMATION REPORT AND CREDIT SCORE, AGGREGATE SCORES, INFERENCES, REFERENCES AND DETAILS (AS DEFINED BELOW) (TOGETHER REFERRED AS “CREDIT INFORMATION”). YOU HEREBY ALSO CONSENT TO SUCH CREDIT INFORMATION BEING PROVIDED BY EXPERIAN TO YOU AND CLIENT BY USING EXPERIAN TOOLS, ALGORITHMS AND DEVICES AND YOU HEREBY AGREE, ACKNOWLEDGE AND ACCEPT THE TERMS AND CONDITIONS SET FORTH HEREIN.</b>
    </p>

    <h4>Terms and Conditions:</h4>
    <h4>Information Collection, Use, Confidentiality, No-Disclosure and Data Purging</h4>
    <ul>
      <li>CLIENT shall access your Credit Information as your authorized representative and CLIENT shall use the Credit Information for limited End Use Purpose in relation to the services proposed to be availed by you from CLIENT.</li>
      <li>We shall not aggregate, retain, store, copy, reproduce, republish, upload, post, transmit, sell or rent the Credit Information to any other person and the same cannot be copied or reproduced other than as agreed herein and in furtherance to applicable law including the CICRA.</li>
      <li>The Parties agree to protect and keep confidential the Credit Information both online and offline.</li>
      <li>The Credit Information shared by You, or received by us on your behalf shall be destroyed, purged, erased immediately upon the completion of the transaction/ End Use Purpose for which the Credit Information report was procured, this period not being longer than 6 months.</li>
    </ul>

    <h4>Governing Law and Jurisdiction</h4>
    <ul>
      <li>The relationship between you and CLIENT shall be governed by laws of India.</li>
      <li>All claims or disputes arising therefrom shall be subject to the exclusive jurisdiction of the courts of Mumbai.</li>
    </ul>

    <h4>Definitions</h4>
    <ul>
      <li><b>“Business Day”</b>: A day (other than a public holiday) on which banks are open for general business in Mumbai.</li>
      <li><b>“Credit Information Report”</b>: The credit information / scores / aggregates / variables / inferences or reports generated by Experian.</li>
      <li><b>“Credit Score”</b>: The score mentioned on the Credit Information Report, computed by Experian.</li>
      <li><b>“CICRA”</b>: The Credit Information Companies (Regulation) Act, 2005, including all applicable rules and regulations.</li>
    </ul>

    <p>
      PLEASE READ THE ABOVEMENTIONED TERMS AND CONDITIONS AND CLICK ON “ACCEPT” FOLLOWED BY THE LINK BELOW TO COMPLETE THE AUTHORISATION PROCESS FOR SHARING YOUR CREDIT INFORMATION BY EXPERIAN WITH CLIENT IN ITS CAPACITY AS YOUR AUTHORISED REPRESENTATIVE.
    </p>

    <p>
      <small>
        This document is an electronic record in terms of the Information Technology Act, 2000 and Rules made thereunder, and the amended provisions pertaining to electronic records.
      </small>
    </p>

  
  </div>
);

export default TermsOfUseExperian;
